var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeriados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 175H49.9999C45.5796 175 41.3404 173.244 38.2148 170.118C35.0892 166.993 33.3333 162.754 33.3333 158.333V58.3333C33.3333 53.9131 35.0892 49.6738 38.2148 46.5482C41.3404 43.4226 45.5796 41.6667 49.9999 41.6667H150C154.42 41.6667 158.659 43.4226 161.785 46.5482C164.911 49.6738 166.667 53.9131 166.667 58.3333V108.333M133.333 25V58.3333M66.6666 25V58.3333M33.3333 91.6667H166.667M141.667 141.667V183.333M175 141.667V183.333",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeriados);
export default __webpack_public_path__ + "static/media/Feriados.7a332f235ad9552a30f135feb4ce74c4.svg";
export { ForwardRef as ReactComponent };